export default __webpack_public_path__ + "static/media/arny.ab8e8631.mp3";